
import React, { forwardRef } from 'react'

import './InputDropdownMenu.scss'

interface Props {
  children: any
  style?: any
  className?: string
}

const InputDropdownMenu = forwardRef(({ children, style, className }: Props, ref: any) => {

  return (
    <div
      ref={ref}
      className={`input-dropdown-menu ${className}`}
      style={style}
    >
      {children}
    </div>
  )
})

InputDropdownMenu.displayName = 'InputDropdownMenu'

export default InputDropdownMenu
